import { render, staticRenderFns } from "./shangHuYeWu.vue?vue&type=template&id=4578eebd&scoped=true"
import script from "./shangHuYeWu.vue?vue&type=script&lang=js"
export * from "./shangHuYeWu.vue?vue&type=script&lang=js"
import style0 from "./shangHuYeWu.vue?vue&type=style&index=0&id=4578eebd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578eebd",
  null
  
)

export default component.exports